"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _common = require("@insided/shared/utils/common");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _cdnImage = require("@insided/shared/utils/cdnImage");

var _experimentalSettings = require("@insided/shared/services/experimental-settings");

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Default `widths` advertised in the auto-generated `srcset`. Covers the
 * common layout slots:
 *   - 240px — thumbnail / avatar-sized
 *   - 480px — small card on mobile
 *   - 960px — full-bleed mobile / half-width desktop card
 *   - 1440px — full-bleed desktop hero
 *
 * Without a `sizes` hint the browser assumes `100vw`, so it picks the
 * largest variant that matches the viewport×DPR — which is conservative
 * but still strictly smaller than the unbounded original upload. Consumers
 * that know their layout slot should pass `sizes` to unlock the real win.
 */
var DEFAULT_WIDTHS = [240, 480, 960, 1440];

var isLazyLoadingActive = function isLazyLoadingActive() {
  if (typeof document === 'undefined') {
    return false;
  }

  if (!_common.common.isModuleActive('lazyLoading') || (0, _globals.default)('application') === 'control') {
    return false;
  }

  var bodyClassList = document.body.classList;
  return bodyClassList.contains('twig_site-index') || _experimentalSettings.experimental.has('topicPagePerformance') && bodyClassList.contains('twig_page-topic');
};
/**
 * Resolves the `srcset` value to apply to the underlying `<img>`.
 *
 * Precedence:
 *   1. An explicit `srcSet` prop wins — used by callers that pre-build a
 *      density-based descriptor (e.g. UserAvatar's 2x/3x set).
 *   2. `displayOriginalImage` opts out entirely.
 *   3. When `widths` is provided, ask the CDN util to build a width-based
 *      descriptor. The util returns an empty string for non-resizable URLs
 *      (gif, off-CDN, already resized) — in that case we emit no `srcset`
 *      and the browser falls back to plain `src`.
 */


var resolveSrcSet = function resolveSrcSet(src, explicitSrcSet, widths, displayOriginalImage) {
  if (typeof explicitSrcSet === 'string' && explicitSrcSet !== '') return explicitSrcSet;
  if (displayOriginalImage === true) return undefined;
  if (widths === undefined || widths.length === 0) return undefined;
  var generated = (0, _cdnImage.buildCdnSrcSet)(src, widths);
  return generated === '' ? undefined : generated;
};

/**
 * Module-level singleton observer shared by every `LazyBackground` instance on
 * the page. Lazily created on first observe, then kept alive for the lifetime
 * of the document — there's no `disconnect()` call by design. Each
 * `LazyBackground` cleans up its own entry in `backgroundCallbacks` and calls
 * `observer.unobserve(target)` on unmount, so the observer's internal target
 * set is bounded by the live DOM. The observer itself is GC'd when the page
 * unloads. The `WeakMap` guarantees that callback closures don't pin
 * detached elements either.
 */
var sharedBackgroundObserver = null;
var backgroundCallbacks = new WeakMap();

var getBackgroundObserver = function getBackgroundObserver() {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    return null;
  }

  if (sharedBackgroundObserver === null) {
    sharedBackgroundObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _sharedBackgroundObse;

        if (!entry.isIntersecting) {
          return;
        }

        var target = entry.target;
        var callback = backgroundCallbacks.get(target);

        if (callback === undefined) {
          return;
        }

        backgroundCallbacks.delete(target);
        (_sharedBackgroundObse = sharedBackgroundObserver) === null || _sharedBackgroundObse === void 0 ? void 0 : _sharedBackgroundObse.unobserve(target);
        callback(target);
      });
    });
  }

  return sharedBackgroundObserver;
};

var observeLazyBackground = function observeLazyBackground(target, callback) {
  var observer = getBackgroundObserver();

  if (observer === null) {
    return false;
  }

  backgroundCallbacks.set(target, callback);
  observer.observe(target);
  return true;
};

var unobserveLazyBackground = function unobserveLazyBackground(target) {
  var _sharedBackgroundObse2;

  backgroundCallbacks.delete(target);
  (_sharedBackgroundObse2 = sharedBackgroundObserver) === null || _sharedBackgroundObse2 === void 0 ? void 0 : _sharedBackgroundObse2.unobserve(target);
};

var resolveImageA11y = function resolveImageA11y(alt, title) {
  var description = alt || title;
  return {
    description: description,
    role: description !== '' ? 'img' : 'presentation'
  };
};

var LazyImg = function LazyImg(_ref) {
  var className = _ref.className,
      src = _ref.src,
      srcSet = _ref.srcSet,
      _ref$widths = _ref.widths,
      widths = _ref$widths === void 0 ? DEFAULT_WIDTHS : _ref$widths,
      sizes = _ref.sizes,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      displayOriginalImage = _ref.displayOriginalImage,
      priority = _ref.priority;

  var _resolveImageA11y = resolveImageA11y(alt, title),
      description = _resolveImageA11y.description,
      role = _resolveImageA11y.role;

  var isLazy = isLazyLoadingActive() && priority !== true;
  var resolvedSrcSet = resolveSrcSet(src, srcSet, widths, displayOriginalImage);
  return (0, _preact.h)("img", {
    role: role,
    className: className,
    src: (0, _absoluteUrlRuntime.resolveUrl)(src),
    srcSet: resolvedSrcSet,
    sizes: resolvedSrcSet === undefined ? undefined : sizes,
    style: style,
    title: title,
    alt: description,
    loading: isLazy ? 'lazy' : 'eager',
    decoding: "async",
    fetchpriority: priority === true ? 'high' : undefined
  });
};

var LazyBackground = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LazyBackground, _Component);

  var _super = _createSuper(LazyBackground);

  function LazyBackground() {
    var _this;

    (0, _classCallCheck2.default)(this, LazyBackground);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      resolvedSrc: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", null);
    return _this;
  }

  (0, _createClass2.default)(LazyBackground, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!isLazyLoadingActive() || this.ref === null) {
        this.setState({
          resolvedSrc: this.props.src
        });
        return;
      }

      var target = this.ref;
      var observed = observeLazyBackground(target, function (element) {
        element.classList.remove('lazy');

        _this2.setState({
          resolvedSrc: _this2.props.src
        });
      });

      if (!observed) {
        this.setState({
          resolvedSrc: this.props.src
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.ref !== null) {
        unobserveLazyBackground(this.ref);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          src = _this$props.src,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$alt = _this$props.alt,
          alt = _this$props$alt === void 0 ? '' : _this$props$alt,
          className = _this$props.className,
          baseWidth = _this$props.baseWidth,
          displayOriginalImage = _this$props.displayOriginalImage;
      var resolvedSrc = this.state.resolvedSrc;

      var _resolveImageA11y2 = resolveImageA11y(alt, title),
          description = _resolveImageA11y2.description,
          role = _resolveImageA11y2.role;

      var isBrowser = typeof window !== 'undefined';

      var resolveBackgroundImage = function resolveBackgroundImage(url) {
        return displayOriginalImage === true ? "url(\"".concat(url, "\")") : (0, _cdnImage.buildBackgroundImageValue)(url, baseWidth);
      };

      if (resolvedSrc !== null) {
        return (0, _preact.h)("div", {
          role: role,
          "aria-label": description,
          className: className,
          style: _objectSpread(_objectSpread({}, style), {}, {
            backgroundImage: resolveBackgroundImage(resolvedSrc)
          }),
          title: title
        }, children);
      }

      return (0, _preact.h)("div", {
        role: role,
        "aria-label": description,
        ref: function ref(_ref2) {
          _this3.ref = _ref2;
        },
        className: (0, _classnames.default)('lazy', className),
        "data-src": src,
        style: isBrowser ? style : _objectSpread(_objectSpread({}, style), {}, {
          backgroundImage: resolveBackgroundImage(src)
        }),
        title: title
      }, children);
    }
  }]);
  return LazyBackground;
}(_preact.Component);

var LazyImage = function LazyImage(props) {
  if (props.type === 'img') {
    return (0, _preact.h)(LazyImg, props);
  }

  return (0, _preact.h)(LazyBackground, props);
};

var _default = LazyImage;
exports.default = _default;